import { Chip } from '@heroui/react';
import i18n from '@/i18n/config';

import type { ContactMessageStatus } from '@/types';

const STATUS_LABELS: Record<ContactMessageStatus, { label: string; color: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' }> = {
  new: { label: i18n.t('copy.new'), color: 'danger' },
  in_progress: { label: i18n.t('copy.in_progress'), color: 'warning' },
  resolved: { label: i18n.t('copy.resolved'), color: 'success' },
  archived: { label: i18n.t('enums.archived'), color: 'default' }
};

interface ContactMessageStatusBadgeProps {
  status: ContactMessageStatus;
  readAt?: string | null;
  className?: string;
}

export function ContactMessageStatusBadge({ status, readAt, className }: ContactMessageStatusBadgeProps) {
  const config = STATUS_LABELS[status];
  const isUnread = status === 'new' && !readAt;

  return (
    <Chip
      className={`gap-1 px-3 py-1 text-xs font-semibold ${className ?? ''}`}
      color={config?.color ?? 'default'}
      size="sm"
      variant={isUnread ? 'solid' : 'flat'}
    >
      {isUnread && <span className="bg-success mr-1 inline-block h-2 w-2 rounded-full" />}
      {config?.label ?? status}
    </Chip>
  );
}

